export default {
      id: "max-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#max-usage",
      toString: function () {
        return this.url;
      }
    }